module.exports = "/_next/static/images/Staging-and-Configuration-97ee78017b4186acdd03df685ee68623.jpg";